module.exports = __webpack_public_path__ + "media/images/lb/106-f72df8627c9dd4c7ab7768706d17801c.svg";